import React, { useState, useEffect } from 'react';

interface TypingPlaceholderProps {
  sentences: string[];
  typingSpeed?: number;
  pauseBetweenSentences?: number;
  className?: string;
}

export const TypingPlaceholder: React.FC<TypingPlaceholderProps> = ({
  sentences,
  typingSpeed = 50,
  pauseBetweenSentences = 2000,
  className = ''
}) => {
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const currentSentence = sentences[currentSentenceIndex];
    
    if (isTyping) {
      // Typing phase
      if (currentText.length < currentSentence.length) {
        const timeout = setTimeout(() => {
          setCurrentText(currentSentence.slice(0, currentText.length + 1));
        }, typingSpeed);
        return () => clearTimeout(timeout);
      } else {
        // Finished typing current sentence, pause before moving to next
        const timeout = setTimeout(() => {
          setIsTyping(false);
        }, pauseBetweenSentences);
        return () => clearTimeout(timeout);
      }
    } else {
      // Erasing phase or moving to next sentence
      if (currentText.length > 0) {
        const timeout = setTimeout(() => {
          setCurrentText(currentText.slice(0, -1));
        }, typingSpeed / 2); // Erase faster than typing
        return () => clearTimeout(timeout);
      } else {
        // Finished erasing, move to next sentence
        setCurrentSentenceIndex((prev) => (prev + 1) % sentences.length);
        setIsTyping(true);
      }
    }
  }, [currentText, currentSentenceIndex, isTyping, sentences, typingSpeed, pauseBetweenSentences]);

  return (
    <div className={`${className} select-none`}>
      <span className="text-gray-400">
        {currentText}{currentText.length === sentences[currentSentenceIndex].length && isTyping && '...'}
      </span>
    </div>
  );
};